import { ZonesOverlayFeatureStateObject } from 'components/MapBox/ZonesOverlay/ZonesOverlay';
import { AreaRating } from 'const/AreaRating';
import {
  CourierPreferencesJson,
  fetchCourierPreferences,
} from 'fetch/fetchCourierPreferences';
import { fetchRatings, ZoneRatingJson } from 'fetch/fetchRatings';
import { useCallback, useEffect, useState } from 'react';
import { CourierJson } from 'types/bundleTypes';

export const useCourierPreferenceData = (selectedCourier: CourierJson) => {
  const [selectedAreas, setSelectedAreas] =
    useState<ZonesOverlayFeatureStateObject[]>();
  const [activeRatingType, setActiveRatingType] = useState<AreaRating>(
    AreaRating.LIKE
  );
  const [essentialData, setEssentialData] = useState<CourierPreferencesJson>();

  const fetchCourierSelectedAreas = useCallback(async () => {
    /* Only get the selectedAreas for selected couriers */
    if (!selectedCourier) {
      return;
    }

    const areas: ZoneRatingJson[] = await fetchRatings(selectedCourier.id);

    const newSelectedAreas = areas.map(area => ({
      id: area.zoneId,
      value: { rating: area.rating },
    }));

    /* Only update when there's new data */
    if (JSON.stringify(newSelectedAreas) !== JSON.stringify(selectedAreas)) {
      setSelectedAreas(newSelectedAreas);
    }
  }, [selectedAreas, selectedCourier]);

  useEffect(() => {
    !selectedAreas && fetchCourierSelectedAreas().catch();
  }, [fetchCourierSelectedAreas, selectedAreas]);

  const fetchEssentialData = useCallback(async () => {
    let newEssentialData = undefined;
    try {
      /* Only get the selected courier's preferences */
      if (selectedCourier) {
        newEssentialData = await fetchCourierPreferences(selectedCourier.id);
      }
    } catch (err) {
      console.error(err);
    }

    /* Only update when there's new data */
    if (JSON.stringify(newEssentialData) !== JSON.stringify(essentialData)) {
      setEssentialData(newEssentialData);
    }
  }, [essentialData, selectedCourier]);

  useEffect(() => {
    fetchEssentialData().catch();
  }, [fetchEssentialData]);

  const onChangeActiveRatingType = (newRatingType: AreaRating) => {
    setActiveRatingType(newRatingType);
  };

  return {
    selectedAreas,
    activeRatingType,
    essentialData,
    onChangeActiveRatingType,
    refreshEssentialData: fetchEssentialData,
    refreshCourierSelectedArea: fetchCourierSelectedAreas,
  };
};
